import { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { Dropdown } from '@app/components';
import { PropsWithClassName } from '@app/constants';

import {
  ADVANCED_SEARCH_FIELD,
  ADVANCED_SEARCH_QUALIFIER,
  advancedSearchMessages,
  BOOLEAN_CHIP,
  TYPES_MAP,
} from '../constants';

import './FieldsDropdown.scss';

type DropdownType = keyof typeof TYPES_MAP;

interface FieldsDropdownProps {
  option: BOOLEAN_CHIP | ADVANCED_SEARCH_QUALIFIER | ADVANCED_SEARCH_FIELD;
  type: DropdownType;
  id: string;
  onSelect: (updatedField) => void;
}

const cnBem = createBemBlockBuilder(['advancedSearchDropdown']);

export const FieldsDropdown: FC<PropsWithClassName<FieldsDropdownProps>> = ({
  option,
  type,
  id,
  className,
  onSelect,
}) => {
  const { $t } = useIntl();
  const typeOptions = TYPES_MAP[type];

  const options = useMemo(
    () =>
      typeOptions.map(field => ({
        label: $t(advancedSearchMessages[field]),
        value: field,
      })),
    [$t, typeOptions]
  );

  return (
    <Dropdown
      id={id}
      items={options}
      hideLabel
      styleType="standard"
      selectedItem={{
        label: $t(
          advancedSearchMessages[option] ||
            advancedSearchMessages[typeOptions[0]]
        ),
        value: option,
      }}
      className={cn(cnBem(), className)}
      onSelectedItemChange={({ selectedItem }) => onSelect(selectedItem?.value)}
    />
  );
};
